import { render } from "./PauseIcon.svg?vue&type=template&id=162ef413"
const script = {}
script.render = render

export default script